import axios from 'axios';
import qs from 'qs';
// const baseUrl = 'https://test.electronicticketapi.ykplg.com/v1/api/';
// const baseUrl = 'http://localhost:8090/v1/api/';
const baseUrl = 'https://common76.yzgnet.com/ticketapi//v1/api/';
// const baseUrl = 'https://electronicticketapi.ykplg.com/v1/api/';

const payUrl = ''

export function post(url, dataobj = {}, token, type) {
	let targetUrl = baseUrl + url;
	let headers = {
		'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
	};
	if (type && type == 'pay') {
		targetUrl = payUrl + url
	}
	if (token) {
		headers = {
			...headers,
			'Authorization': token
		}
	}
	return new Promise((resolve, reject) => {
		axios.post(
			targetUrl,
			qs.stringify(dataobj),
			//contentType:"application/json;charset=utf-8"
			{
				headers: headers
			}
		).then(result => {
			const {
				data
			} = result
			resolve(data);
		}, err => {
			reject(err)
		})
	})
}
